export default {"src":"/_next/static/media/restart.3441b8d5.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};